import { languages } from "../constants/languages";

export const getAllLanguages = async () => {
    return { results: languages };
}
